import React, { useEffect, useState } from "react";
import { useTheme } from "../../context/ThemeContext";
import "./TutorQuestionCard.css";
import { addQuestionApi } from "../../api/api";

const InputTutorQuestionCard = ({ propSetId, questionAddedSuccess }) => {
    const [questionData, setQuestionData] = useState({
        question: "",
        options: ["", "", "", ""], // Default 4 options
        answer: "",
    });
    const [setId, setSetId] = useState(propSetId)

    const { themeStyles } = useTheme();

    useEffect(() => {
        setSetId(propSetId)
    }, [propSetId])

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setQuestionData((prev) => ({ ...prev, [name]: value }));
    };

    const handleOptionChange = (index, value) => {
        const updatedOptions = [...questionData.options];
        updatedOptions[index] = value;
        setQuestionData((prev) => ({ ...prev, options: updatedOptions }));
    };

    const handleAnswerSelect = (index) => {
        setQuestionData((prev) => ({ ...prev, answer: questionData.options[index] }));
    };

    const addQuestion = async () => {

        if (!questionData.question || !questionData.answer) alert("Please add all the required fields");

        questionData.options.map((item) => {
            if (item == "") alert("Please add all the options")
        })

        const payload = {
            setId: setId,
            question: questionData.question,
            options: questionData.options,
            answer: questionData.answer
        }
        try {
            const response = await addQuestionApi(payload);
            if (response.success) {

            }
            questionAddedSuccess(setId);
        } catch (error) {
            console.log("question added err", error);
        }
    }

    return (
        <div
            className="tutor-question-card"
            style={{
                background: themeStyles.cardBackground,
                color: themeStyles.text,
                border: `1px solid ${themeStyles.text}`,
                borderRadius: "8px",
                padding: "16px",
                position: "relative",
                boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                overflow: "hidden",
            }}
        >

            {/* Input Form */}
            <div style={{ marginBottom: "16px" }}>
                <label style={{ display: "block", marginBottom: "8px" }}>
                    <strong>Question:</strong>
                </label>
                <input
                    type="textarea"
                    name="question"
                    value={questionData.question}
                    onChange={handleInputChange}
                    style={{
                        width: "100%",
                        padding: "8px",
                        borderRadius: "4px",
                        border: `1px solid ${themeStyles.text}`,
                        backgroundColor: themeStyles.cardContentBackground,
                        color: themeStyles.text,
                    }}
                    placeholder="Enter your question here"
                />
            </div>

            <div className="options" style={{ marginBottom: "8px" }}>
                <strong>Options:</strong>
                <ul style={{ listStyleType: "none", paddingLeft: "0" }}>
                    {questionData.options.map((option, index) => (
                        <li
                            key={index}
                            style={{
                                marginBottom: "8px",
                                padding: "8px",
                                border: `1px solid ${themeStyles.text}`,
                                borderRadius: "4px",
                                backgroundColor: themeStyles.cardContentBackground,
                                display: 'flex',
                                flexDirection: 'row'
                            }}
                        >
                            <input
                                type="text"
                                value={option}
                                onChange={(e) => handleOptionChange(index, e.target.value)}
                                placeholder={`Option ${index + 1}`}
                                style={{
                                    width: "87%",
                                    padding: "8px",
                                    border: "none",
                                    backgroundColor: "transparent",
                                    color: themeStyles.text,
                                }}
                            />
                            <button
                                type="button"
                                onClick={() => handleAnswerSelect(index)}
                                style={{
                                    padding: "4px 8px",
                                    marginLeft: "8px",
                                    borderRadius: "4px",
                                    backgroundColor:
                                        questionData.answer === option ? "green" : themeStyles.text,
                                    color: questionData.answer === option ? "#FFF" : themeStyles.cardBackground == "#FFFFFF" ? "#FFF" : "#424242",
                                    border: "none",
                                    cursor: "pointer",
                                }}
                            >
                                Mark as Answer
                            </button>
                        </li>
                    ))}
                </ul>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <button
                        type="button"
                        onClick={addQuestion}
                        style={{
                            marginTop: 10,
                            padding: "8px 16px",
                            borderRadius: "4px",
                            backgroundColor: themeStyles.primaryColor,
                            color: "#FFF",
                            border: "none",
                            cursor: "pointer",
                        }}
                    >
                        Add Question
                    </button>
                </div>

            </div>

            {/* Display Selected Answer */}
            {questionData.answer && (
                <div>
                    <strong>Correct Answer:</strong> {questionData.answer}
                </div>
            )}
        </div>
    );
};

export default InputTutorQuestionCard;
